var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('span',{staticClass:"loading-icon"}),_c('IndexInfo',{attrs:{"indexInfo":_vm.indexInfo}}),_c('Metrics',{attrs:{"indexName":_vm.indexName,"metrics":_vm.metrics}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }